/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DesktopFromJSONTyped, DesktopToJSON, } from './Desktop.js';
import { MobileFromJSONTyped, MobileToJSON, } from './Mobile.js';
import { TabletFromJSONTyped, TabletToJSON, } from './Tablet.js';
export function DeviceFromJSON(json) {
    return DeviceFromJSONTyped(json, false);
}
export function DeviceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'desktop':
            return Object.assign(Object.assign({}, DesktopFromJSONTyped(json, true)), { type: 'desktop' });
        case 'mobile':
            return Object.assign(Object.assign({}, MobileFromJSONTyped(json, true)), { type: 'mobile' });
        case 'tablet':
            return Object.assign(Object.assign({}, TabletFromJSONTyped(json, true)), { type: 'tablet' });
        default:
            throw new Error(`No variant of Device exists with 'type=${json['type']}'`);
    }
}
export function DeviceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'desktop':
            return DesktopToJSON(value);
        case 'mobile':
            return MobileToJSON(value);
        case 'tablet':
            return TabletToJSON(value);
        default:
            throw new Error(`No variant of Device exists with 'type=${value['type']}'`);
    }
}
